import React from 'react';
import { SWRConfig } from 'swr';
import { swrFetcher } from '../lib/swrFetcher';

import type { ConfigInterface } from 'swr';

const SWRConfigWithFetcher: React.FC<{ config?: ConfigInterface }> = ({
  config,
  children,
}) => (
  <SWRConfig value={{ fetcher: swrFetcher, ...(config ? config : {}) }}>
    {children}
  </SWRConfig>
);

export { SWRConfigWithFetcher };
